/**
 * Linear Adhesive Bundle Functionality (Roll Vinyl)
 * Handles flooring + adhesive bundle for linear products. Single adhesive, no dropdown.
 * Adhesive coverage comes from the adhesive's pack_coverage metafield.
 * Namespaced to avoid clashing with the underlay bundle (window.bundleData).
 */

// Show adhesive bundle option for linear products
function showLinearAdhesiveOption(flooringQuantity, totalArea) {
    if (typeof window.linearAdhesiveBundleData === 'undefined') {
        return;
    }

    const bundleContainer = document.getElementById('linearAdhesiveBundle');
    if (!bundleContainer) {
        return;
    }

    const data = window.linearAdhesiveBundleData;
    const packCoverage = data.adhesivePackCoverage || data.adhesiveCoverageRatio || 1.0;
    const divisionResult = totalArea / packCoverage;
    const adhesiveQuantity = Math.max(1, Math.ceil(divisionResult));

    const flooringQtyEl = document.getElementById('linearAdhesiveBundleFlooringQuantity');
    const adhesiveQtyEl = document.getElementById('linearAdhesiveBundleAdhesiveQuantity');
    if (flooringQtyEl) flooringQtyEl.textContent = flooringQuantity;
    if (adhesiveQtyEl) adhesiveQtyEl.textContent = adhesiveQuantity;

    const flooringTotal = flooringQuantity * (data.flooringPrice / 100);
    const adhesiveTotal = adhesiveQuantity * (data.adhesivePrice / 100);
    const individualTotal = flooringTotal + adhesiveTotal;

    const discountPercentage = data.bundleDiscountPercentage || 0;
    const adhesiveDiscountAmount = Math.floor(adhesiveTotal * (discountPercentage / 100) * 100) / 100;
    const discountedAdhesiveTotal = adhesiveTotal - adhesiveDiscountAmount;
    const bundleTotal = flooringTotal + discountedAdhesiveTotal;

    const flooringPriceEl = document.getElementById('linearAdhesiveBundleFlooringPrice');
    const adhesivePriceEl = document.getElementById('linearAdhesiveBundleAdhesivePrice');
    const adhesivePriceDiscountedEl = document.getElementById('linearAdhesiveBundleAdhesivePriceDiscounted');
    const individualTotalEl = document.getElementById('linearAdhesiveBundleIndividualTotal');
    const discountEl = document.getElementById('linearAdhesiveBundleDiscount');
    const bundleTotalEl = document.getElementById('linearAdhesiveBundleTotal');
    const savingsAmountEl = document.getElementById('linearAdhesiveBundleSavingsAmount');

    if (flooringPriceEl) flooringPriceEl.textContent = '£' + flooringTotal.toFixed(2);

    if (discountPercentage > 0) {
        if (adhesivePriceEl) {
            adhesivePriceEl.textContent = '£' + adhesiveTotal.toFixed(2);
            adhesivePriceEl.style.display = 'block';
        }
        if (adhesivePriceDiscountedEl) {
            adhesivePriceDiscountedEl.textContent = '£' + discountedAdhesiveTotal.toFixed(2);
            adhesivePriceDiscountedEl.style.display = 'block';
        }
    } else {
        if (adhesivePriceEl) {
            adhesivePriceEl.textContent = '£' + adhesiveTotal.toFixed(2);
            adhesivePriceEl.style.textDecoration = 'none';
            adhesivePriceEl.style.color = '#3D4E5F';
        }
        if (adhesivePriceDiscountedEl) {
            adhesivePriceDiscountedEl.style.display = 'none';
        }
    }

    if (individualTotalEl) individualTotalEl.textContent = '£' + individualTotal.toFixed(2);
    if (discountEl) discountEl.textContent = '-£' + adhesiveDiscountAmount.toFixed(2);
    if (bundleTotalEl) bundleTotalEl.textContent = '£' + bundleTotal.toFixed(2);
    if (savingsAmountEl) savingsAmountEl.textContent = '£' + adhesiveDiscountAmount.toFixed(2);

    data.calculatedFlooringQuantity = flooringQuantity;
    data.calculatedAdhesiveQuantity = adhesiveQuantity;

    bundleContainer.style.display = 'block';
    bundleContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

// Hide adhesive bundle
function hideLinearAdhesiveBundle() {
    const bundleContainer = document.getElementById('linearAdhesiveBundle');
    if (bundleContainer) {
        bundleContainer.style.display = 'none';
    }
}

// Add bundle to cart (flooring + adhesive)
function addLinearAdhesiveBundleToCart() {
    if (typeof window.linearAdhesiveBundleData === 'undefined') {
        console.error('Adhesive bundle data not available');
        return;
    }

    const data = window.linearAdhesiveBundleData;
    const flooringQuantity = data.calculatedFlooringQuantity || 1;
    const adhesiveQuantity = data.calculatedAdhesiveQuantity || 1;

    const widthSelect = document.getElementById('linearWidthSelect');
    const widthValue = widthSelect ? widthSelect.value : '0';
    const lengthInput = document.getElementById('linearLengthInput');
    const lengthValue = lengthInput ? lengthInput.value : '0';
    const variant = window.linearProductData?.currentVariant;
    const variantSku = variant?.sku || '';
    const bundleId = Date.now().toString();
    const discountText = document.getElementById('linearAdhesiveBundleDiscount')?.textContent ?? '0';

    const items = [
        {
            id: data.flooringVariantId,
            quantity: flooringQuantity,
            properties: {
                '_bundle': 'flooring-adhesive',
                '_bundle_id': bundleId,
                '_bundle_type': 'flooring',
                '_bundle_category': 'vinyl',
                '_bundle_discount': data.bundleDiscountPercentage,
                '_bundle_total_discount': discountText,
                'SKU': variantSku,
                'Width (m)': widthValue,
                'Length (m)': lengthValue,
                '_cut_id': bundleId
            }
        },
        {
            id: data.adhesiveVariantId,
            quantity: adhesiveQuantity,
            properties: {
                '_bundle': 'flooring-adhesive',
                '_bundle_id': bundleId,
                '_bundle_type': 'adhesive',
                '_bundle_category': 'vinyl',
                '_bundle_discount': data.bundleDiscountPercentage,
                '_bundle_total_discount': discountText
            }
        }
    ];

    const addButton = document.getElementById('addLinearAdhesiveBundleToCart');
    const originalText = addButton ? addButton.innerHTML : '';
    if (addButton) {
        addButton.disabled = true;
        addButton.innerHTML = 'Adding...';
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(responseData => {
        if (responseData.status && (responseData.status === 'error' || (typeof responseData.status === 'number' && responseData.status >= 400))) {
            throw new Error(responseData.message || responseData.description || 'Failed to add to cart');
        }
        return responseData;
    })
    .then(responseData => {
        if (typeof showCartSuccessToast === 'function') {
            const bundleTotal = document.getElementById('linearAdhesiveBundleTotal')?.textContent || '';
            showCartSuccessToast(1, `Bundle: ${data.flooringProductTitle} + ${data.adhesiveProductTitle} (${bundleTotal})`);
        }
        hideLinearAdhesiveBundle();
        document.dispatchEvent(new CustomEvent('cart:update', { detail: responseData }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: responseData }));
        if (addButton) {
            addButton.disabled = false;
            addButton.innerHTML = originalText;
        }
    })
    .catch(error => {
        console.error('Error adding adhesive bundle to cart:', error);
        alert('Error adding to cart: ' + error.message);
        if (addButton) {
            addButton.disabled = false;
            addButton.innerHTML = originalText;
        }
    });
}

// Add just flooring (no adhesive)
function addLinearJustFlooringFromAdhesiveBundle() {
    if (typeof window.linearAdhesiveBundleData === 'undefined') {
        console.error('Adhesive bundle data not available');
        return;
    }

    const data = window.linearAdhesiveBundleData;
    const flooringQuantity = data.calculatedFlooringQuantity || 1;

    const widthSelect = document.getElementById('linearWidthSelect');
    const widthValue = widthSelect ? widthSelect.value : '0';
    const lengthInput = document.getElementById('linearLengthInput');
    const lengthValue = lengthInput ? lengthInput.value : '0';
    const variant = window.linearProductData?.currentVariant;
    const variantSku = variant?.sku || '';

    const justFlooringBtn = document.querySelector('.linear-adhesive-bundle-secondary-btn');
    const originalText = justFlooringBtn ? justFlooringBtn.innerHTML : '';
    if (justFlooringBtn) {
        justFlooringBtn.disabled = true;
        justFlooringBtn.innerHTML = 'Adding...';
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: data.flooringVariantId,
            quantity: flooringQuantity,
            properties: {
                'SKU': variantSku,
                'Width (m)': widthValue,
                'Length (m)': lengthValue,
                '_cut_id': Date.now().toString()
            }
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add to cart');
        }
        return response.json();
    })
    .then(responseData => {
        if (typeof showCartSuccessToast === 'function') {
            showCartSuccessToast(flooringQuantity, data.flooringProductTitle || 'Flooring');
        }
        hideLinearAdhesiveBundle();
        document.dispatchEvent(new CustomEvent('cart:update', { detail: responseData }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: responseData }));
        if (justFlooringBtn) {
            justFlooringBtn.disabled = false;
            justFlooringBtn.innerHTML = originalText;
        }
    })
    .catch(error => {
        console.error('Error adding flooring to cart:', error);
        alert('Error adding to cart. Please try again.');
        if (justFlooringBtn) {
            justFlooringBtn.disabled = false;
            justFlooringBtn.innerHTML = originalText;
        }
    });
}
